import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TButtonTheme } from '@cian/ui-kit/button/types/TButtonTheme';
import { Button } from '@cian/ui-kit';

import { getIsAuthenticated } from '../../selectors/user';
import { requestAuthentication } from '../../actions/authentication';
import { setNewQuestionFormOpen } from '../../actions/newQuestion';

export interface INewReviewButtonProps {
  size?: 'XS' | 'M' | 'L';
  fill?: TButtonTheme;
  fullWidth?: boolean;
  withModerationLink?: boolean;
}

export function NewQuestionButtonContainer({
  size = 'M',
  fill = 'fill_primary',
  fullWidth = true,
}: INewReviewButtonProps) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(getIsAuthenticated);

  const handleOpenQuestionForm = React.useCallback(() => {
    if (isAuthenticated) {
      dispatch(setNewQuestionFormOpen());
    } else {
      dispatch(requestAuthentication({ onSuccess: setNewQuestionFormOpen }));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <Button
      data-testid="NewQuestionButton"
      size={size}
      fullWidth={fullWidth}
      theme={fill}
      onClick={handleOpenQuestionForm}
    >
      Задать вопрос
    </Button>
  );
}
